import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

const books = [
  // Self-Help & Personal Development
  {
    title: "Atomic Habits",
    author: "James Clear",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0735211299.01.L.jpg",
    pages: 320,
    description: "An easy & proven way to build good habits & break bad ones.",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2018,
    isbn: "0735211299"
  },
  {
    title: "The 7 Habits of Highly Effective People",
    author: "Stephen Covey",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1982137274.01.L.jpg",
    pages: 464,
    description: "Powerful lessons in personal change.",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 1989,
    isbn: "1982137274"
  },
  {
    title: "Think and Grow Rich",
    author: "Napoleon Hill",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1585424331.01.L.jpg",
    pages: 320,
    description: "The Landmark Bestseller Now Revised and Updated for the 21st Century",
    categories: ["Personal Development", "Finance"],
    publishedYear: 1937,
    isbn: "1585424331"
  },

  // Business & Leadership
  {
    title: "Good to Great",
    author: "Jim Collins",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0066620996.01.L.jpg",
    pages: 400,
    description: "Why Some Companies Make the Leap...And Others Don't",
    categories: ["Business", "Leadership"],
    publishedYear: 2001,
    isbn: "0066620996"
  },
  {
    title: "Zero to One",
    author: "Peter Thiel",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0804139296.01.L.jpg",
    pages: 224,
    description: "Notes on Startups, or How to Build the Future",
    categories: ["Business", "Entrepreneurship"],
    publishedYear: 2014,
    isbn: "0804139296"
  },

  // Investment & Finance
  {
    title: "The Psychology of Money",
    author: "Morgan Housel",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0857197681.01.L.jpg",
    pages: 256,
    description: "Timeless lessons on wealth, greed, and happiness",
    categories: ["Finance", "Psychology"],
    publishedYear: 2020,
    isbn: "0857197681"
  },
  {
    title: "Rich Dad Poor Dad",
    author: "Robert T. Kiyosaki",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1612680194.01.L.jpg",
    pages: 336,
    description: "What the Rich Teach Their Kids About Money",
    categories: ["Finance", "Personal Development"],
    publishedYear: 1997,
    isbn: "1612680194"
  },

  // Philosophy & Wisdom
  {
    title: "The Almanack of Naval Ravikant",
    author: "Eric Jorgenson",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1544514212.01.L.jpg",
    pages: 242,
    description: "A Guide to Wealth and Happiness",
    categories: ["Philosophy", "Personal Development"],
    publishedYear: 2020,
    isbn: "1544514212"
  },
  {
    title: "Meditations",
    author: "Marcus Aurelius",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0812968255.01.L.jpg",
    pages: 256,
    description: "A New Translation by Gregory Hays",
    categories: ["Philosophy", "Stoicism"],
    publishedYear: 180,
    isbn: "0812968255"
  },

  // Productivity
  {
    title: "Deep Work",
    author: "Cal Newport",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1455586692.01.L.jpg",
    pages: 296,
    description: "Rules for Focused Success in a Distracted World",
    categories: ["Productivity", "Business"],
    publishedYear: 2016,
    isbn: "1455586692"
  },
  {
    title: "Getting Things Done",
    author: "David Allen",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0143126563.01.L.jpg",
    pages: 352,
    description: "The Art of Stress-Free Productivity",
    categories: ["Productivity", "Self-Help"],
    publishedYear: 2015,
    isbn: "0143126563"
  },

  // More Self-Help & Personal Development
  {
    title: "Can't Hurt Me",
    author: "David Goggins",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1544512287.01.L.jpg",
    pages: 364,
    description: "Master Your Mind and Defy the Odds",
    categories: ["Self-Help", "Motivation"],
    publishedYear: 2018,
    isbn: "1544512287"
  },
  {
    title: "The Mountain Is You",
    author: "Brianna Wiest",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1949759229.01.L.jpg",
    pages: 248,
    description: "Transforming Self-Sabotage Into Self-Mastery",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2020,
    isbn: "1949759229"
  },
  {
    title: "The Subtle Art of Not Giving a F*ck",
    author: "Mark Manson",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0062457713.01.L.jpg",
    pages: 224,
    description: "A Counterintuitive Approach to Living a Good Life",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2016,
    isbn: "0062457713"
  },

  // More Business & Leadership
  {
    title: "Start with Why",
    author: "Simon Sinek",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1591846447.01.L.jpg",
    pages: 256,
    description: "How Great Leaders Inspire Everyone to Take Action",
    categories: ["Business", "Leadership"],
    publishedYear: 2011,
    isbn: "1591846447"
  },
  {
    title: "Built to Last",
    author: "Jim Collins",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0060516402.01.L.jpg",
    pages: 368,
    description: "Successful Habits of Visionary Companies",
    categories: ["Business", "Leadership"],
    publishedYear: 2004,
    isbn: "0060516402"
  },
  {
    title: "The Lean Startup",
    author: "Eric Ries",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0307887898.01.L.jpg",
    pages: 336,
    description: "How Today's Entrepreneurs Use Continuous Innovation",
    categories: ["Business", "Entrepreneurship"],
    publishedYear: 2011,
    isbn: "0307887898"
  },

  // More Investment & Finance
  {
    title: "The Intelligent Investor",
    author: "Benjamin Graham",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0060555661.01.L.jpg",
    pages: 640,
    description: "The Definitive Book on Value Investing",
    categories: ["Finance", "Investment"],
    publishedYear: 2006,
    isbn: "0060555661"
  },
  {
    title: "Security Analysis",
    author: "Benjamin Graham",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0071592539.01.L.jpg",
    pages: 700,
    description: "Principles and Technique",
    categories: ["Finance", "Investment"],
    publishedYear: 2008,
    isbn: "0071592539"
  },
  {
    title: "One Up On Wall Street",
    author: "Peter Lynch",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0743200403.01.L.jpg",
    pages: 304,
    description: "How To Use What You Already Know To Make Money In The Market",
    categories: ["Finance", "Investment"],
    publishedYear: 2000,
    isbn: "0743200403"
  },

  // More Philosophy & Wisdom
  {
    title: "The Daily Stoic",
    author: "Ryan Holiday",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0735211736.01.L.jpg",
    pages: 416,
    description: "366 Meditations on Wisdom, Perseverance, and the Art of Living",
    categories: ["Philosophy", "Stoicism"],
    publishedYear: 2016,
    isbn: "0735211736"
  },
  {
    title: "Letters from a Stoic",
    author: "Seneca",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0141395850.01.L.jpg",
    pages: 256,
    description: "Epistulae Morales Ad Lucilium",
    categories: ["Philosophy", "Stoicism"],
    publishedYear: 65,
    isbn: "0141395850"
  },
  {
    title: "Man's Search for Meaning",
    author: "Viktor E. Frankl",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0807014273.01.L.jpg",
    pages: 184,
    description: "The Classic Tribute to Hope from the Holocaust",
    categories: ["Philosophy", "Psychology"],
    publishedYear: 2006,
    isbn: "0807014273"
  },

  // More Productivity & Time Management
  {
    title: "Essentialism",
    author: "Greg McKeown",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0804137382.01.L.jpg",
    pages: 272,
    description: "The Disciplined Pursuit of Less",
    categories: ["Productivity", "Self-Help"],
    publishedYear: 2014,
    isbn: "0804137382"
  },
  {
    title: "The One Thing",
    author: "Gary Keller",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1885167776.01.L.jpg",
    pages: 240,
    description: "The Surprisingly Simple Truth Behind Extraordinary Results",
    categories: ["Productivity", "Business"],
    publishedYear: 2013,
    isbn: "1885167776"
  },

  // Psychology & Mental Models
  {
    title: "Thinking, Fast and Slow",
    author: "Daniel Kahneman",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0374533555.01.L.jpg",
    pages: 499,
    description: "How we make decisions and how to make better ones",
    categories: ["Psychology", "Decision Making"],
    publishedYear: 2011,
    isbn: "0374533555"
  },
  {
    title: "Predictably Irrational",
    author: "Dan Ariely",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0061353248.01.L.jpg",
    pages: 384,
    description: "The Hidden Forces That Shape Our Decisions",
    categories: ["Psychology", "Behavioral Economics"],
    publishedYear: 2008,
    isbn: "0061353248"
  },
  {
    title: "The Power of Habit",
    author: "Charles Duhigg",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/081298160X.01.L.jpg",
    pages: 371,
    description: "Why We Do What We Do in Life and Business",
    categories: ["Psychology", "Self-Help"],
    publishedYear: 2012,
    isbn: "081298160X"
  },

  // More Investment & Finance
  {
    title: "Common Stocks and Uncommon Profits",
    author: "Philip Fisher",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0471445509.01.L.jpg",
    pages: 320,
    description: "Essential principles of investment success",
    categories: ["Finance", "Investment"],
    publishedYear: 2003,
    isbn: "0471445509"
  },
  {
    title: "The Little Book of Common Sense Investing",
    author: "John C. Bogle",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1119404509.01.L.jpg",
    pages: 304,
    description: "The Only Way to Guarantee Your Fair Share of Stock Market Returns",
    categories: ["Finance", "Investment"],
    publishedYear: 2017,
    isbn: "1119404509"
  },
  {
    title: "A Random Walk Down Wall Street",
    author: "Burton Malkiel",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0393358380.01.L.jpg",
    pages: 432,
    description: "The Time-Tested Strategy for Successful Investing",
    categories: ["Finance", "Investment"],
    publishedYear: 2020,
    isbn: "0393358380"
  },

  // More Business Strategy
  {
    title: "Blue Ocean Strategy",
    author: "W. Chan Kim",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1591396190.01.L.jpg",
    pages: 240,
    description: "How to Create Uncontested Market Space",
    categories: ["Business", "Strategy"],
    publishedYear: 2005,
    isbn: "1591396190"
  },
  {
    title: "Crossing the Chasm",
    author: "Geoffrey A. Moore",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0062292986.01.L.jpg",
    pages: 288,
    description: "Marketing and Selling Disruptive Products",
    categories: ["Business", "Marketing"],
    publishedYear: 2014,
    isbn: "0062292986"
  },
  {
    title: "The Innovator's Dilemma",
    author: "Clayton M. Christensen",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1633691780.01.L.jpg",
    pages: 288,
    description: "When New Technologies Cause Great Firms to Fail",
    categories: ["Business", "Innovation"],
    publishedYear: 2016,
    isbn: "1633691780"
  },

  // More Personal Development
  {
    title: "Mindset",
    author: "Carol S. Dweck",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0345472322.01.L.jpg",
    pages: 320,
    description: "The New Psychology of Success",
    categories: ["Psychology", "Personal Development"],
    publishedYear: 2006,
    isbn: "0345472322"
  },
  {
    title: "Daring Greatly",
    author: "Brené Brown",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1592408419.01.L.jpg",
    pages: 320,
    description: "How the Courage to Be Vulnerable Transforms",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2012,
    isbn: "1592408419"
  },
  {
    title: "Flow",
    author: "Mihaly Csikszentmihalyi",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0061339202.01.L.jpg",
    pages: 336,
    description: "The Psychology of Optimal Experience",
    categories: ["Psychology", "Personal Development"],
    publishedYear: 2008,
    isbn: "0061339202"
  },

  // More Modern Philosophy
  {
    title: "The Obstacle Is the Way",
    author: "Ryan Holiday",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1591846358.01.L.jpg",
    pages: 224,
    description: "The Timeless Art of Turning Trials into Triumph",
    categories: ["Philosophy", "Stoicism"],
    publishedYear: 2014,
    isbn: "1591846358"
  },
  {
    title: "Ego Is the Enemy",
    author: "Ryan Holiday",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1591847818.01.L.jpg",
    pages: 256,
    description: "The Fight to Master Our Greatest Opponent",
    categories: ["Philosophy", "Personal Development"],
    publishedYear: 2016,
    isbn: "1591847818"
  },

  // More Business & Entrepreneurship
  {
    title: "High Output Management",
    author: "Andrew S. Grove",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0679762884.01.L.jpg",
    pages: 272,
    description: "The essential guide to management from the former CEO of Intel",
    categories: ["Business", "Management"],
    publishedYear: 1995,
    isbn: "0679762884"
  },
  {
    title: "The Hard Thing About Hard Things",
    author: "Ben Horowitz",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0062273205.01.L.jpg",
    pages: 304,
    description: "Building a Business When There Are No Easy Answers",
    categories: ["Business", "Leadership"],
    publishedYear: 2014,
    isbn: "0062273205"
  },
  {
    title: "Rework",
    author: "Jason Fried",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0307463745.01.L.jpg",
    pages: 288,
    description: "Change The Way You Work Forever",
    categories: ["Business", "Entrepreneurship"],
    publishedYear: 2010,
    isbn: "0307463745"
  },

  // More Investment & Wealth Building
  {
    title: "The Total Money Makeover",
    author: "Dave Ramsey",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1595555277.01.L.jpg",
    pages: 272,
    description: "A Proven Plan for Financial Fitness",
    categories: ["Finance", "Personal Development"],
    publishedYear: 2013,
    isbn: "1595555277"
  },
  {
    title: "The Simple Path to Wealth",
    author: "JL Collins",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1533667926.01.L.jpg",
    pages: 286,
    description: "Your Road Map to Financial Independence",
    categories: ["Finance", "Investment"],
    publishedYear: 2016,
    isbn: "1533667926"
  },
  {
    title: "The Millionaire Fastlane",
    author: "M.J. DeMarco",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0984358102.01.L.jpg",
    pages: 336,
    description: "Crack the Code to Wealth and Live Rich for a Lifetime",
    categories: ["Finance", "Entrepreneurship"],
    publishedYear: 2011,
    isbn: "0984358102"
  },

  // More Psychology & Mental Models
  {
    title: "Influence",
    author: "Robert B. Cialdini",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/006124189X.01.L.jpg",
    pages: 336,
    description: "The Psychology of Persuasion",
    categories: ["Psychology", "Marketing"],
    publishedYear: 2006,
    isbn: "006124189X"
  },
  {
    title: "Quiet",
    author: "Susan Cain",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0307352153.01.L.jpg",
    pages: 352,
    description: "The Power of Introverts in a World That Can't Stop Talking",
    categories: ["Psychology", "Personal Development"],
    publishedYear: 2012,
    isbn: "0307352153"
  },
  {
    title: "Superforecasting",
    author: "Philip E. Tetlock",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0804136718.01.L.jpg",
    pages: 352,
    description: "The Art and Science of Prediction",
    categories: ["Psychology", "Decision Making"],
    publishedYear: 2015,
    isbn: "0804136718"
  },

  // More Personal Development & Success
  {
    title: "The 4-Hour Work Week",
    author: "Timothy Ferriss",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0307465357.01.L.jpg",
    pages: 416,
    description: "Escape 9-5, Live Anywhere, and Join the New Rich",
    categories: ["Personal Development", "Business"],
    publishedYear: 2009,
    isbn: "0307465357"
  },
  {
    title: "The War of Art",
    author: "Steven Pressfield",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1936891026.01.L.jpg",
    pages: 190,
    description: "Break Through the Blocks and Win Your Inner Creative Battles",
    categories: ["Personal Development", "Creativity"],
    publishedYear: 2012,
    isbn: "1936891026"
  },
  {
    title: "Digital Minimalism",
    author: "Cal Newport",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0525536515.01.L.jpg",
    pages: 304,
    description: "Choosing a Focused Life in a Noisy World",
    categories: ["Personal Development", "Technology"],
    publishedYear: 2019,
    isbn: "0525536515"
  },

  // More Modern Philosophy & Mindfulness
  {
    title: "The Power of Now",
    author: "Eckhart Tolle",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1577314808.01.L.jpg",
    pages: 236,
    description: "A Guide to Spiritual Enlightenment",
    categories: ["Philosophy", "Spirituality"],
    publishedYear: 2004,
    isbn: "1577314808"
  },
  {
    title: "Awareness",
    author: "Anthony De Mello",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0385249373.01.L.jpg",
    pages: 184,
    description: "The Perils and Opportunities of Reality",
    categories: ["Philosophy", "Spirituality"],
    publishedYear: 1990,
    isbn: "0385249373"
  },
  {
    title: "The Book of Joy",
    author: "Dalai Lama",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0399185046.01.L.jpg",
    pages: 384,
    description: "Lasting Happiness in a Changing World",
    categories: ["Philosophy", "Happiness"],
    publishedYear: 2016,
    isbn: "0399185046"
  },

  // More Business Strategy & Leadership
  {
    title: "Principles",
    author: "Ray Dalio",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1501124021.01.L.jpg",
    pages: 592,
    description: "Life and Work",
    categories: ["Business", "Leadership"],
    publishedYear: 2017,
    isbn: "1501124021"
  },
  {
    title: "Never Split the Difference",
    author: "Chris Voss",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0062407805.01.L.jpg",
    pages: 288,
    description: "Negotiating As If Your Life Depended On It",
    categories: ["Business", "Psychology"],
    publishedYear: 2016,
    isbn: "0062407805"
  },
  {
    title: "The Culture Code",
    author: "Daniel Coyle",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0804176981.01.L.jpg",
    pages: 304,
    description: "The Secrets of Highly Successful Groups",
    categories: ["Business", "Leadership"],
    publishedYear: 2018,
    isbn: "0804176981"
  },

  // More Investment & Wealth Building
  {
    title: "The Most Important Thing",
    author: "Howard Marks",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0231153686.01.L.jpg",
    pages: 200,
    description: "Uncommon Sense for the Thoughtful Investor",
    categories: ["Finance", "Investment"],
    publishedYear: 2011,
    isbn: "0231153686"
  },
  {
    title: "The Little Book That Still Beats the Market",
    author: "Joel Greenblatt",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0470624159.01.L.jpg",
    pages: 208,
    description: "A proven market-beating formula",
    categories: ["Finance", "Investment"],
    publishedYear: 2010,
    isbn: "0470624159"
  },
  {
    title: "The Bogleheads' Guide to Investing",
    author: "Taylor Larimore",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1118921283.01.L.jpg",
    pages: 336,
    description: "The simple path to building wealth",
    categories: ["Finance", "Investment"],
    publishedYear: 2014,
    isbn: "1118921283"
  },

  // More Psychology & Mental Models
  {
    title: "Poor Charlie's Almanack",
    author: "Charles T. Munger",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1578645018.01.L.jpg",
    pages: 512,
    description: "The Wit and Wisdom of Charles T. Munger",
    categories: ["Psychology", "Investment"],
    publishedYear: 2005,
    isbn: "1578645018"
  },
  {
    title: "The Laws of Human Nature",
    author: "Robert Greene",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0525428143.01.L.jpg",
    pages: 624,
    description: "Understanding people's drives and motivations",
    categories: ["Psychology", "Self-Help"],
    publishedYear: 2018,
    isbn: "0525428143"
  },
  {
    title: "Range",
    author: "David Epstein",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0735214484.01.L.jpg",
    pages: 352,
    description: "Why Generalists Triumph in a Specialized World",
    categories: ["Psychology", "Personal Development"],
    publishedYear: 2019,
    isbn: "0735214484"
  },

  // More Personal Development & Success
  {
    title: "Ultralearning",
    author: "Scott Young",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/006285268X.01.L.jpg",
    pages: 304,
    description: "Master Hard Skills, Outsmart the Competition",
    categories: ["Personal Development", "Learning"],
    publishedYear: 2019,
    isbn: "006285268X"
  },
  {
    title: "Peak",
    author: "Anders Ericsson",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0544947223.01.L.jpg",
    pages: 336,
    description: "Secrets from the New Science of Expertise",
    categories: ["Personal Development", "Psychology"],
    publishedYear: 2016,
    isbn: "0544947223"
  },
  {
    title: "So Good They Can't Ignore You",
    author: "Cal Newport",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1455509124.01.L.jpg",
    pages: 288,
    description: "Why Skills Trump Passion in the Quest for Work You Love",
    categories: ["Personal Development", "Career"],
    publishedYear: 2012,
    isbn: "1455509124"
  },

  // More Modern Philosophy & Mindfulness
  {
    title: "Stillness Is the Key",
    author: "Ryan Holiday",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0525538585.01.L.jpg",
    pages: 288,
    description: "Finding peace and productivity",
    categories: ["Philosophy", "Personal Development"],
    publishedYear: 2019,
    isbn: "0525538585"
  },
  {
    title: "The Untethered Soul",
    author: "Michael A. Singer",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1572245379.01.L.jpg",
    pages: 200,
    description: "The Journey Beyond Yourself",
    categories: ["Philosophy", "Spirituality"],
    publishedYear: 2007,
    isbn: "1572245379"
  },
  {
    title: "The Courage to Be Disliked",
    author: "Ichiro Kishimi",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1501197274.01.L.jpg",
    pages: 288,
    description: "How to Free Yourself, Change Your Life and Achieve Real Happiness",
    categories: ["Philosophy", "Psychology"],
    publishedYear: 2018,
    isbn: "1501197274"
  },

  // More Business Strategy & Innovation
  {
    title: "Hooked",
    author: "Nir Eyal",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1591847788.01.L.jpg",
    pages: 256,
    description: "How to Build Habit-Forming Products",
    categories: ["Business", "Psychology"],
    publishedYear: 2014,
    isbn: "1591847788"
  },
  {
    title: "Measure What Matters",
    author: "John Doerr",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0525536221.01.L.jpg",
    pages: 320,
    description: "How Google, Bono, and the Gates Foundation Rock the World with OKRs",
    categories: ["Business", "Management"],
    publishedYear: 2018,
    isbn: "0525536221"
  },
  {
    title: "Traction",
    author: "Gabriel Weinberg",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0241242533.01.L.jpg",
    pages: 240,
    description: "How Any Startup Can Achieve Explosive Customer Growth",
    categories: ["Business", "Marketing"],
    publishedYear: 2015,
    isbn: "0241242533"
  },

  // More Investment & Trading
  {
    title: "Market Wizards",
    author: "Jack D. Schwager",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1118273052.01.L.jpg",
    pages: 512,
    description: "Interviews with Top Traders",
    categories: ["Finance", "Trading"],
    publishedYear: 2012,
    isbn: "1118273052"
  },
  {
    title: "The Little Book of Value Investing",
    author: "Christopher H. Browne",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0470055898.01.L.jpg",
    pages: 208,
    description: "Essential value investing strategies",
    categories: ["Finance", "Investment"],
    publishedYear: 2007,
    isbn: "0470055898"
  },
  {
    title: "What I Learned Losing a Million Dollars",
    author: "Jim Paul",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0231164688.01.L.jpg",
    pages: 192,
    description: "Essential lessons in risk management",
    categories: ["Finance", "Psychology"],
    publishedYear: 2013,
    isbn: "0231164688"
  },

  // More Psychology & Decision Making
  {
    title: "Nudge",
    author: "Richard H. Thaler",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/014311526X.01.L.jpg",
    pages: 312,
    description: "Improving Decisions About Health, Wealth, and Happiness",
    categories: ["Psychology", "Economics"],
    publishedYear: 2009,
    isbn: "014311526X"
  },
  {
    title: "Switch",
    author: "Chip Heath",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0385528752.01.L.jpg",
    pages: 305,
    description: "How to Change Things When Change Is Hard",
    categories: ["Psychology", "Business"],
    publishedYear: 2010,
    isbn: "0385528752"
  },
  {
    title: "Misbehaving",
    author: "Richard H. Thaler",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0393352795.01.L.jpg",
    pages: 432,
    description: "The Making of Behavioral Economics",
    categories: ["Psychology", "Economics"],
    publishedYear: 2016,
    isbn: "0393352795"
  },

  // More Personal Development & Productivity
  {
    title: "Make Time",
    author: "Jake Knapp",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0525572422.01.L.jpg",
    pages: 304,
    description: "How to Focus on What Matters Every Day",
    categories: ["Productivity", "Personal Development"],
    publishedYear: 2018,
    isbn: "0525572422"
  },
  {
    title: "Indistractable",
    author: "Nir Eyal",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/194883653X.01.L.jpg",
    pages: 300,
    description: "How to Control Your Attention and Choose Your Life",
    categories: ["Productivity", "Psychology"],
    publishedYear: 2019,
    isbn: "194883653X"
  },
  {
    title: "The Practice",
    author: "Seth Godin",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0593328973.01.L.jpg",
    pages: 272,
    description: "Shipping Creative Work",
    categories: ["Creativity", "Personal Development"],
    publishedYear: 2020,
    isbn: "0593328973"
  },

  // More Philosophy & Life Strategy
  {
    title: "The Art of Living",
    author: "Epictetus",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0061286052.01.L.jpg",
    pages: 128,
    description: "The Classical Manual on Virtue, Happiness, and Effectiveness",
    categories: ["Philosophy", "Stoicism"],
    publishedYear: 2007,
    isbn: "0061286052"
  },
  {
    title: "The Happiness of Pursuit",
    author: "Chris Guillebeau",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0385348843.01.L.jpg",
    pages: 304,
    description: "Finding the Quest That Will Bring Purpose to Your Life",
    categories: ["Philosophy", "Personal Development"],
    publishedYear: 2014,
    isbn: "0385348843"
  },
  {
    title: "The Wisdom of Insecurity",
    author: "Alan Watts",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0307741206.01.L.jpg",
    pages: 152,
    description: "A Message for an Age of Anxiety",
    categories: ["Philosophy", "Psychology"],
    publishedYear: 2011,
    isbn: "0307741206"
  },

  // More Business & Leadership
  {
    title: "Creativity, Inc.",
    author: "Ed Catmull",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0812993012.01.L.jpg",
    pages: 368,
    description: "Overcoming the Unseen Forces That Stand in the Way of True Inspiration",
    categories: ["Business", "Creativity"],
    publishedYear: 2014,
    isbn: "0812993012"
  },
  {
    title: "The E-Myth Revisited",
    author: "Michael E. Gerber",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0887307280.01.L.jpg",
    pages: 288,
    description: "Why Most Small Businesses Don't Work and What to Do About It",
    categories: ["Business", "Entrepreneurship"],
    publishedYear: 2004,
    isbn: "0887307280"
  },
  {
    title: "The Goal",
    author: "Eliyahu M. Goldratt",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0884271951.01.L.jpg",
    pages: 384,
    description: "A Process of Ongoing Improvement",
    categories: ["Business", "Management"],
    publishedYear: 2014,
    isbn: "0884271951"
  },

  // More Investment & Finance
  {
    title: "The Black Swan",
    author: "Nassim Nicholas Taleb",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/081297381X.01.L.jpg",
    pages: 480,
    description: "The Impact of the Highly Improbable",
    categories: ["Finance", "Philosophy"],
    publishedYear: 2010,
    isbn: "081297381X"
  },
  {
    title: "Fooled by Randomness",
    author: "Nassim Nicholas Taleb",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0812975219.01.L.jpg",
    pages: 368,
    description: "The Hidden Role of Chance in Life and in the Markets",
    categories: ["Finance", "Psychology"],
    publishedYear: 2005,
    isbn: "0812975219"
  },
  {
    title: "The Psychology of Trading",
    author: "Brett N. Steenbarger",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0471267619.01.L.jpg",
    pages: 330,
    description: "Tools and Techniques for Minding the Markets",
    categories: ["Finance", "Psychology"],
    publishedYear: 2003,
    isbn: "0471267619"
  },

  // More Psychology & Mental Models
  {
    title: "Antifragile",
    author: "Nassim Nicholas Taleb",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0812979680.01.L.jpg",
    pages: 544,
    description: "Things That Gain from Disorder",
    categories: ["Psychology", "Philosophy"],
    publishedYear: 2014,
    isbn: "0812979680"
  },
  {
    title: "The Undoing Project",
    author: "Michael Lewis",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0393354776.01.L.jpg",
    pages: 368,
    description: "A Friendship That Changed Our Minds",
    categories: ["Psychology", "Economics"],
    publishedYear: 2017,
    isbn: "0393354776"
  },
  {
    title: "Mastery",
    author: "Robert Greene",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/014312417X.01.L.jpg",
    pages: 368,
    description: "The Keys to Success and Long-Term Fulfillment",
    categories: ["Psychology", "Personal Development"],
    publishedYear: 2012,
    isbn: "014312417X"
  },

  // More Personal Development & Success
  {
    title: "Mindfulness in Plain English",
    author: "Bhante Henepola Gunaratana",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0861719069.01.L.jpg",
    pages: 224,
    description: "A Classic Guide to Developing Awareness",
    categories: ["Personal Development", "Spirituality"],
    publishedYear: 2011,
    isbn: "0861719069"
  },
  {
    title: "The Talent Code",
    author: "Daniel Coyle",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/055380684X.01.L.jpg",
    pages: 288,
    description: "Greatness Isn't Born. It's Grown",
    categories: ["Personal Development", "Psychology"],
    publishedYear: 2009,
    isbn: "055380684X"
  },
  {
    title: "Grit",
    author: "Angela Duckworth",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1501111108.01.L.jpg",
    pages: 352,
    description: "The Power of Passion and Perseverance",
    categories: ["Personal Development", "Psychology"],
    publishedYear: 2016,
    isbn: "1501111108"
  },

  // More Modern Business & Tech
  {
    title: "The Lean Product Playbook",
    author: "Dan Olsen",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1118960874.01.L.jpg",
    pages: 336,
    description: "How to Innovate with Minimum Viable Products",
    categories: ["Business", "Product Development"],
    publishedYear: 2015,
    isbn: "1118960874"
  },
  {
    title: "Platform Revolution",
    author: "Geoffrey G. Parker",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0393354350.01.L.jpg",
    pages: 352,
    description: "How Networked Markets Are Transforming the Economy",
    categories: ["Business", "Technology"],
    publishedYear: 2016,
    isbn: "0393354350"
  },
  {
    title: "Blitzscaling",
    author: "Reid Hoffman",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1524761419.01.L.jpg",
    pages: 336,
    description: "The Lightning-Fast Path to Building Massively Valuable Companies",
    categories: ["Business", "Entrepreneurship"],
    publishedYear: 2018,
    isbn: "1524761419"
  },

  // More Advanced Finance
  {
    title: "The Most Important Thing Illuminated",
    author: "Howard Marks",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0231162847.01.L.jpg",
    pages: 248,
    description: "Uncommon Sense for the Thoughtful Investor",
    categories: ["Finance", "Investment"],
    publishedYear: 2013,
    isbn: "0231162847"
  },
  {
    title: "You Can Be a Stock Market Genius",
    author: "Joel Greenblatt",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0684840073.01.L.jpg",
    pages: 304,
    description: "Uncover the Secret Hiding Places of Stock Market Profits",
    categories: ["Finance", "Investment"],
    publishedYear: 1999,
    isbn: "0684840073"
  },
  {
    title: "The Essays of Warren Buffett",
    author: "Lawrence A. Cunningham",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1531017509.01.L.jpg",
    pages: 350,
    description: "Lessons for Corporate America",
    categories: ["Finance", "Business"],
    publishedYear: 2019,
    isbn: "1531017509"
  },

  // More Advanced Psychology
  {
    title: "Behave",
    author: "Robert M. Sapolsky",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0143110918.01.L.jpg",
    pages: 800,
    description: "The Biology of Humans at Our Best and Worst",
    categories: ["Psychology", "Science"],
    publishedYear: 2017,
    isbn: "0143110918"
  },
  {
    title: "The Body Keeps the Score",
    author: "Bessel van der Kolk",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0143127748.01.L.jpg",
    pages: 464,
    description: "Brain, Mind, and Body in the Healing of Trauma",
    categories: ["Psychology", "Health"],
    publishedYear: 2014,
    isbn: "0143127748"
  },
  {
    title: "Thinking in Systems",
    author: "Donella H. Meadows",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1603580557.01.L.jpg",
    pages: 240,
    description: "A Primer",
    categories: ["Psychology", "Science"],
    publishedYear: 2008,
    isbn: "1603580557"
  },

  // More Career Development
  {
    title: "Designing Your Life",
    author: "Bill Burnett",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1101875321.01.L.jpg",
    pages: 272,
    description: "How to Build a Well-Lived, Joyful Life",
    categories: ["Personal Development", "Career"],
    publishedYear: 2016,
    isbn: "1101875321"
  },
  {
    title: "Range",
    author: "David Epstein",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0735214484.01.L.jpg",
    pages: 352,
    description: "Why Generalists Triumph in a Specialized World",
    categories: ["Personal Development", "Career"],
    publishedYear: 2019,
    isbn: "0735214484"
  },
  {
    title: "The Alliance",
    author: "Reid Hoffman",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1625275773.01.L.jpg",
    pages: 224,
    description: "Managing Talent in the Networked Age",
    categories: ["Business", "Career"],
    publishedYear: 2014,
    isbn: "1625275773"
  },

  // Self-Love & Personal Growth
  {
    title: "The Self-Love Experiment",
    author: "Shannon Kaiser",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0143130692.01.L.jpg",
    pages: 320,
    description: "Fifteen Principles for Becoming More Kind, Compassionate, and Accepting of Yourself",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2017,
    isbn: "0143130692"
  },
  {
    title: "The Gifts of Imperfection",
    author: "Brené Brown",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0593133587.01.L.jpg",
    pages: 208,
    description: "Let Go of Who You Think You're Supposed to Be and Embrace Who You Are",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2020,
    isbn: "0593133587"
  },
  {
    title: "Self-Compassion",
    author: "Kristin Neff",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0061733520.01.L.jpg",
    pages: 320,
    description: "The Proven Power of Being Kind to Yourself",
    categories: ["Self-Help", "Psychology"],
    publishedYear: 2015,
    isbn: "0061733520"
  },

  // Personal Optimization & Performance
  {
    title: "Tools of Titans",
    author: "Timothy Ferriss",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1328683788.01.L.jpg",
    pages: 704,
    description: "The Tactics, Routines, and Habits of Billionaires, Icons, and World-Class Performers",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2016,
    isbn: "1328683788"
  },
  {
    title: "High Performance Habits",
    author: "Brendon Burchard",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1401952852.01.L.jpg",
    pages: 400,
    description: "How Extraordinary People Become That Way",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2017,
    isbn: "1401952852"
  },
  {
    title: "The Code of the Extraordinary Mind",
    author: "Vishen Lakhiani",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1635411998.01.L.jpg",
    pages: 288,
    description: "10 Unconventional Laws to Redefine Your Life",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2019,
    isbn: "1635411998"
  },

  // Mental Optimization & Growth
  {
    title: "Limitless",
    author: "Jim Kwik",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1401958230.01.L.jpg",
    pages: 344,
    description: "Upgrade Your Brain, Learn Anything Faster, and Unlock Your Exceptional Life",
    categories: ["Self-Help", "Learning"],
    publishedYear: 2020,
    isbn: "1401958230"
  },
  {
    title: "The Mind Illuminated",
    author: "Culadasa",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1501156985.01.L.jpg",
    pages: 512,
    description: "A Complete Meditation Guide",
    categories: ["Self-Help", "Spirituality"],
    publishedYear: 2017,
    isbn: "1501156985"
  },
  {
    title: "Hyperfocus",
    author: "Chris Bailey",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0525522239.01.L.jpg",
    pages: 256,
    description: "How to Be More Productive in a World of Distraction",
    categories: ["Self-Help", "Productivity"],
    publishedYear: 2018,
    isbn: "0525522239"
  },

  // Life Optimization & Balance
  {
    title: "The Joy of Missing Out",
    author: "Tonya Dalton",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1400214335.01.L.jpg",
    pages: 240,
    description: "Live More by Doing Less",
    categories: ["Self-Help", "Lifestyle"],
    publishedYear: 2019,
    isbn: "1400214335"
  },
  {
    title: "Tiny Habits",
    author: "BJ Fogg",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0358003326.01.L.jpg",
    pages: 320,
    description: "The Small Changes That Change Everything",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2019,
    isbn: "0358003326"
  },
  {
    title: "The Happiness Equation",
    author: "Neil Pasricha",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0425277984.01.L.jpg",
    pages: 320,
    description: "Want Nothing + Do Anything = Have Everything",
    categories: ["Self-Help", "Happiness"],
    publishedYear: 2016,
    isbn: "0425277984"
  },

  // Emotional Intelligence & Growth
  {
    title: "Permission to Feel",
    author: "Marc Brackett",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1250212847.01.L.jpg",
    pages: 304,
    description: "Unlocking the Power of Emotions to Help Our Kids, Ourselves, and Our Society Thrive",
    categories: ["Self-Help", "Psychology"],
    publishedYear: 2019,
    isbn: "1250212847"
  },
  {
    title: "Emotional Agility",
    author: "Susan David",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1592409490.01.L.jpg",
    pages: 288,
    description: "Get Unstuck, Embrace Change, and Thrive in Work and Life",
    categories: ["Self-Help", "Psychology"],
    publishedYear: 2016,
    isbn: "1592409490"
  },
  {
    title: "Atlas of the Heart",
    author: "Brené Brown",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0399592555.01.L.jpg",
    pages: 336,
    description: "Mapping Meaningful Connection and the Language of Human Experience",
    categories: ["Self-Help", "Psychology"],
    publishedYear: 2021,
    isbn: "0399592555"
  },

  // More Self-Love & Inner Work
  {
    title: "Love Yourself Like Your Life Depends on It",
    author: "Kamal Ravikant",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0062968726.01.L.jpg",
    pages: 224,
    description: "A powerful, practical approach to self-love",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2020,
    isbn: "0062968726"
  },
  {
    title: "The Self-Love Workbook",
    author: "Shainna Ali",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1612438660.01.L.jpg",
    pages: 174,
    description: "A Life-Changing Guide to Boost Self-Esteem",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2018,
    isbn: "1612438660"
  },
  {
    title: "What to Say When You Talk to Yourself",
    author: "Shad Helmstetter",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1501171992.01.L.jpg",
    pages: 256,
    description: "Powerful New Techniques to Program Your Potential for Success",
    categories: ["Self-Help", "Psychology"],
    publishedYear: 2017,
    isbn: "1501171992"
  },

  // Personal Growth & Transformation
  {
    title: "Radical Self-Acceptance",
    author: "Tara Brach",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0553380990.01.L.jpg",
    pages: 352,
    description: "A Buddhist Guide to Freeing Yourself from Shame",
    categories: ["Self-Help", "Spirituality"],
    publishedYear: 2004,
    isbn: "0553380990"
  },
  {
    title: "The Artist's Way",
    author: "Julia Cameron",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0143129252.01.L.jpg",
    pages: 272,
    description: "A Spiritual Path to Higher Creativity",
    categories: ["Self-Help", "Creativity"],
    publishedYear: 2016,
    isbn: "0143129252"
  },
  {
    title: "Loving What Is",
    author: "Byron Katie",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1400045371.01.L.jpg",
    pages: 321,
    description: "Four Questions That Can Change Your Life",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2003,
    isbn: "1400045371"
  },

  // Life Optimization & Personal Excellence
  {
    title: "Mindset: The Psychology of Success",
    author: "Carol S. Dweck",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0345472322.01.L.jpg",
    pages: 320,
    description: "How we can learn to fulfill our potential",
    categories: ["Self-Help", "Psychology"],
    publishedYear: 2006,
    isbn: "0345472322"
  },
  {
    title: "Super Human",
    author: "Dave Asprey",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0062882821.01.L.jpg",
    pages: 352,
    description: "The Bulletproof Plan to Age Backward",
    categories: ["Self-Help", "Health"],
    publishedYear: 2019,
    isbn: "0062882821"
  },
  {
    title: "The 5 AM Club",
    author: "Robin Sharma",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1443456624.01.L.jpg",
    pages: 336,
    description: "Own Your Morning, Elevate Your Life",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2018,
    isbn: "1443456624"
  },

  // Mental Mastery & Emotional Intelligence
  {
    title: "Emotional Intelligence 2.0",
    author: "Travis Bradberry",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0974320625.01.L.jpg",
    pages: 280,
    description: "Strategies for Increasing Your EQ",
    categories: ["Self-Help", "Psychology"],
    publishedYear: 2009,
    isbn: "0974320625"
  },
  {
    title: "The Confidence Gap",
    author: "Russ Harris",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1590309235.01.L.jpg",
    pages: 240,
    description: "From Fear to Freedom",
    categories: ["Self-Help", "Psychology"],
    publishedYear: 2011,
    isbn: "1590309235"
  },
  {
    title: "The Happiness of Pursuit",
    author: "Chris Guillebeau",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0385348843.01.L.jpg",
    pages: 304,
    description: "Finding the Quest That Will Bring Purpose to Your Life",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2014,
    isbn: "0385348843"
  },

  // Wellness & Life Balance
  {
    title: "The Sleep Revolution",
    author: "Arianna Huffington",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/1101904008.01.L.jpg",
    pages: 400,
    description: "Transforming Your Life, One Night at a Time",
    categories: ["Self-Help", "Health"],
    publishedYear: 2016,
    isbn: "1101904008"
  },
  {
    title: "Breath",
    author: "James Nestor",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0735213615.01.L.jpg",
    pages: 304,
    description: "The New Science of a Lost Art",
    categories: ["Self-Help", "Health"],
    publishedYear: 2020,
    isbn: "0735213615"
  },
  {
    title: "The Energy Bus",
    author: "Jon Gordon",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/P/0470100281.01.L.jpg",
    pages: 192,
    description: "10 Rules to Fuel Your Life, Work, and Team with Positive Energy",
    categories: ["Self-Help", "Personal Development"],
    publishedYear: 2007,
    isbn: "0470100281"
  }
];

export const seedBooks = async () => {
  try {
    const booksRef = collection(db, 'books');
    
    for (const book of books) {
      const bookWithMetadata = {
        ...book,
        addedAt: new Date().toISOString(),
        rating: 0,
        ratingCount: 0,
        status: 'active'
      };

      await addDoc(booksRef, bookWithMetadata);
      console.log(`Added book: ${book.title}`);
    }

    console.log('Successfully added all books!');
  } catch (error) {
    console.error('Error seeding books:', error);
    throw error;
  }
}; 